import * as React from 'react'
import { Text, View, StyleSheet } from 'react-native'
import { GoBackButton } from '@components/ButtonsAlt/GoBackButton'
import Fonts from '@themes/Fonts'

export function EmptyList() {
  return (
    <View style={styles.container}>
      <Text style={styles.message}>No needs available.</Text>
      <GoBackButton />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 100,
  },
  message: {
    fontFamily: Fonts.type.bold,
    fontWeight: 'bold',
    fontSize: 26,
    marginBottom: 16,
  },
})
